module.exports = __webpack_public_path__ + "img/not-found-hero-image.bf2318bb.png";